import { Link } from '../Link';
import styles from './LinkCloud.module.scss';

export interface LinkCloudItemProps {
  href: string;
  title: string;
  label: string;
  ariaLabel?: string;
  target?: string;
  rel?: string;
}

interface LinkCloudProps {
  links: LinkCloudItemProps[];
  testId: string;
}

export const LinkCloud: React.FC<LinkCloudProps> = ({ links, testId }) => (
  <ul className={styles.list} data-testid={testId}>
    {links.map((link, index) => (
      <li key={`link-cloud-${index}`} className={styles.item}>
        <Link
          href={link.href}
          title={link.title}
          ariaLabel={link.ariaLabel}
          target={link.target}
          rel={link.rel}
          className={styles.link}
          data-testid={`${testId}-link-${index + 1}`}
        >
          {link.label}
        </Link>
      </li>
    ))}
  </ul>
);
